module.exports = __webpack_public_path__ + "media/images/official-2-2cb5e3ffdcae627661bd0b37adc32e7b.png";